<!-- <template>
    <HelloWorld msg="Welcome to Your Vue.js App" />
 
</template> -->
<template>
    <Toast />
    <router-view></router-view>
</template>

<script>
import { useRouter } from "vue-router";
// import HelloWorld from "./components/HelloWorld.vue";
// import HomePage from "./ui/admin/home/HomePage.vue";
export default {
    name: "App",
    // components: {
    //     HomePage,
    // },
};
</script>

<style></style>
